module.exports = __webpack_public_path__ + "img/logo.197053e9.svg";